/**
 * Pixel Meta — chargé UNIQUEMENT sur le funnel de recrutement public
 * (landing `/candidature` + parcours de test `/regie-test/:token`). On ne
 * l'active jamais sur le reste du cockpit : pas question de tracer l'équipe
 * interne ni de polluer les données d'optimisation de Meta.
 *
 * Événements :
 *  - `PageView`            — chargement d'une page du funnel (via `initPixel`)
 *  - `Lead`                — le candidat ENVOIE le formulaire (profil accepté
 *                            par le serveur ; au clic « Postuler » jusqu'au 07-10)
 *  - `CompleteRegistration`— le candidat va jusqu'au bout du test
 *
 * « A réussi / recrutable » est décidé côté serveur (le score n'est jamais
 * exposé au candidat) → ça se branchera en phase 2 via l'API Conversions,
 * pas ici.
 */
const PIXEL_ID = "1595035982202564";

type FbqFn = ((...args: unknown[]) => void) & {
  queue: unknown[];
  loaded: boolean;
  version: string;
  push?: unknown;
  callMethod?: (...args: unknown[]) => void;
};

declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: unknown;
  }
}

let injected = false;

/** Injecte le script fbevents une seule fois (patron officiel Meta, typé). */
function injectBase(): void {
  if (injected || typeof window === "undefined") return;
  injected = true;

  const n = ((...args: unknown[]) => {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  }) as FbqFn;
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  n.push = n;

  window.fbq = n;
  if (!window._fbq) window._fbq = n;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  n("init", PIXEL_ID);
}

/** Charge le pixel (idempotent) et enregistre une vue de page du funnel. */
export function initPixel(): void {
  injectBase();
  window.fbq?.("track", "PageView");
}

/** Enregistre un événement standard Meta (`Lead`, `CompleteRegistration`, …). */
export function trackPixel(event: string, params?: Record<string, unknown>): void {
  window.fbq?.("track", event, params);
}
